var _defs, _polygon, _path, _circle, _line, _line2, _line3, _path2, _polyline, _polyline2, _path3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient",
    "data-name": "paper gradient",
    x1: 7.1028,
    y1: 14.6843,
    x2: 32.8921,
    y2: 40.4736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad",
    "data-name": "Dark Blue Grad",
    x1: 26.1612,
    y1: 26.1612,
    x2: 43.8388,
    y2: 43.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73b4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    stopColor: "#6aaec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    stopColor: "#529eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    stopColor: "#2c839f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1.133 34.5 12.602 14.686 15.499 19.717 9.865 29.5 30.137 29.5 17.147 6.828 19.996 1.792 38.866 34.5 1.133 34.5",
    fill: "url(#paper_gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8,38,34H2L12.6006,15.6861l2.3206,4.031L9,30H31L17.7227,6.8267,20,2.8M19.9914.7839,19.13,2.3077,16.8522,6.3345l-.28.4955.283.4939L29.2745,29H10.73l5.058-8.7839.2873-.4989-.2873-.499-2.3206-4.031-.8642-1.5013-.8679,1.4993L1.1345,33.499.2657,35H39.7314l-.8652-1.5-18-31.2L19.9914.7839Z",
    fill: "#464646"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 12.5,
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 32.5,
    x2: 30.5,
    y2: 32.5,
    fill: "none",
    stroke: "#147391",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 35.5,
    x2: 28.5,
    y2: 35.5,
    fill: "none",
    stroke: "#147391",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 38.5,
    x2: 29.5,
    y2: 38.5,
    fill: "none",
    stroke: "#147391",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.05,30.05a7,7,0,1,1,0,9.8994",
    fill: "none",
    stroke: "#147391",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "36 31.022 36 35 37.46 36.46",
    fill: "none",
    stroke: "#147391",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "36 31.022 36 35 37.46 36.46",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.05,30.05a7,7,0,1,1,0,9.8994",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27.5,
    y1: 32.5,
    x2: 30.5,
    y2: 32.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.5,
    y1: 35.5,
    x2: 28.5,
    y2: 35.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 38.5,
    x2: 29.5,
    y2: 38.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScTypeIcon);
export default __webpack_public_path__ + "static/media/sc-type-icon.e0d81766c2ea365bd1a5170da813ae24.svg";
export { ForwardRef as ReactComponent };